module.exports = __webpack_public_path__ + "static/eric-schmidt-9eeeaa408c415376fbd1e70a3066ee50.jpg";